import { render, staticRenderFns } from "./registerChart.vue?vue&type=template&id=5a205f23&"
import script from "./registerChart.vue?vue&type=script&lang=js&"
export * from "./registerChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports